const tags = [
  {
    tagName: '#escalated',
    suffix: '',
    description: 'Escalated shipment',
  },
  {
    tagName: '#faa',
    suffix: '',
    description: 'First available appointment',
  },
  {
    tagName: '#ufr',
    suffix: '',
    description: 'Unresponsive receiver',
  },
  {
    tagName: '#ufs',
    suffix: '',
    description: 'Unresponsive shipper',
  },
  {
    tagName: '#NTA',
    suffix: '',
    description: 'Non-Tracking Approval',
  },
  {
    tagName: '#NA',
    suffix: 'MC',
    description: 'B - No Answer',
  },
  {
    tagName: '#CLAIM',
    suffix: '',
    description: 'B - Claim',
  },
  {
    tagName: '#B_NoOTP',
    suffix: '',
    description: 'Bounce - Not empty or too far away',
  },
  {
    tagName: '#B_Rejected',
    suffix: '',
    description: 'Bounce - Rejected',
  },
  {
    tagName: '#B_MechIssue',
    suffix: '',
    description: 'Bounce - Truck breakdown',
  },
  {
    tagName: '#B_CantContact',
    suffix: '',
    description: 'Bounce - Cannot contact carrier',
  },
  {
    tagName: '#B_NoDL',
    suffix: '',
    description: 'Bounce - No download',
  },
  {
    tagName: '#B_NoDocs',
    suffix: '',
    description: 'Bounce - No BCA or Safety letter',
  },
  {
    tagName: '#B_CarrierNeg',
    suffix: '',
    description: 'Bounce - Carrier Negligence',
  },
  {
    tagName: '#B_ShipperChange',
    suffix: '',
    description: 'Bounce - Shipper Error',
  },
  {
    tagName: '#B_MisComm',
    suffix: '',
    description: 'Bounce - TF error',
  },
  {
    tagName: '#B_SwitchLoads',
    suffix: '',
    description: 'Bounce - Switched loads',
  },
  {
    tagName: '#B_NoTrack',
    suffix: '',
    description: 'Bounce - Carrier Not Tracking',
  },
  {
    tagName: '#TN',
    suffix: '',
    description: 'T&T - Tracking note',
  },
  {
    tagName: '#OOP_customer_denied',
    suffix: '',
    description: 'customer denied a justifiable request',
  },
  {
    tagName: '#OOP_customer_policy',
    suffix: '',
    description: 'request from carrier is justified but falls outside of their policy',
  },
  {
    tagName: '#OOP_customer_strategic',
    suffix: '',
    description: 'decided not to request/charge customer for strategic reasons',
  },
  {
    tagName: '#OOP_unreasonable_carrier',
    suffix: '',
    description: 'carrier required unreasonable amount',
  },
  {
    tagName: '#OOP_clerical',
    suffix: '',
    description: 'AM issue-typo, inaccurate info, etc.',
  },
  {
    tagName: '#OOP_booking_issue',
    suffix: '',
    description: 'CM issue-incorrect info, booked late, etc',
  },
  {
    tagName: '#wrong_driver_info',
    suffix: '',
    description: 'Wrong driver info provided',
  },
  {
    tagName: '#appointment_request',
    suffix: '',
    description: 'Appointment request submitted',
  },
  {
    tagName: '#appfail_flipphone',
    suffix: '',
    description: "Driver's phone doesn't support app",
  },
  {
    tagName: '#appfail_error',
    suffix: '',
    description: "Driver is receiving error messages and can't complete the dl",
  },
  {
    tagName: '#appfail_carrierneg',
    suffix: '',
    description: 'Driver refusing to download app',
  },
  {
    tagName: '#appfail_NA',
    suffix: '',
    description: 'Carrier is unresponsive to tracking requests',
  },
  {
    tagName: '#appfail_ce',
    suffix: '',
    description: 'CE team did not reach out to get driver tracking',
  },
  {
    tagName: '#appfail_cm',
    suffix: '',
    description: 'CM did not sell level one load with tracking',
  },
  {
    tagName: '#appfail_attempt',
    suffix: '',
    description: 'Driver attempted to download the app but failed to set it up',
  },
  {
    tagName: '#app_dl',
    suffix: '',
    description: 'App downloaded successfully',
  },
  {
    tagName: '#app_pend',
    suffix: '',
    description: 'App download attempt made',
  },
  {
    tagName: '#app_fail',
    suffix: '',
    description: 'App download failure',
  },
  {
    tagName: '#app_channel',
    suffix: '',
    description: 'App download attempt sourced from must track channel',
  },
  {
    tagName: '#dummy',
    suffix: '',
    description: 'Unknown in/out time',
  },
  {
    tagName: '#dummyresolved',
    suffix: '',
    description: '#dummy time corrected',
  },
  {
    tagName: '#reschedule_pu',
    suffix: '',
    description: 'reschedule pickup',
  },
  {
    tagName: '#reschedule_del',
    suffix: '',
    description: 'reschedule delivery',
  },
  {
    tagName: '#reschedule',
    suffix: '',
    description: 'reschedule the load',
  },
  {
    tagName: '#p44_dl',
    suffix: '',
    description: 'load is pinging through p44',
  },
  {
    tagName: '#p44_pend',
    suffix: '',
    description: 'waiting on p44 ping',
  },
  {
    tagName: '#p44fail_bug',
    suffix: '',
    description: 'truck number confirmed but location is wrong or no p44 ping',
  },
  {
    tagName: '#p44fail_na',
    suffix: '',
    description: 'carrier is unresponsive 2x',
  },
  {
    tagName: '#p44fail_ctn',
    suffix: '',
    description: "truck number invalid but carrier confirmed it's correct",
  },
  {
    tagName: '#p44fail_other',
    suffix: '',
    description: 'miscellaneous',
  },
  {
    tagName: '#trailernotready',
    suffix: '',
    description: 'trailer not ready',
  },
]

export const HASHTAGS = tags.map(tag => {
  return {
    ...tag,
    label: `${tag.tagName}: ${tag.description}`,
    nickname: `${tag.tagName.slice(1)} ${tag.suffix}`,
    type: '#',
  }
})
